import type { ActivityTab } from './recordingActivity';

/**
 * The support articles the Activity section's info link opens, one per tab. The apps open
 * the same three from their stats cards (iOS `RecordingSupportArticle`, Android `BlogUrls`).
 *
 * `?post_type=article&p=<id>` rather than the pretty permalink: the support site 301s the
 * short form to whatever the published permalink is, so a draft's link works once it's live.
 */
const SUPPORT_ARTICLE = 'https://support.hiiker.app/?post_type=article&p=';

export const ACTIVITY_ARTICLE_IDS = {
  heartRatePaceSteps: 4576,
  ascent: 4768,
} as const;

/** Elevation is the summary, with no article of its own, so it has no link. */
export function activityInfoUrl(tab: ActivityTab): string | null {
  switch (tab) {
    case 'elevation':
      return null;
    case 'ascent':
      return SUPPORT_ARTICLE + ACTIVITY_ARTICLE_IDS.ascent;
    case 'heartRate':
    case 'steps':
    case 'pace':
      return SUPPORT_ARTICLE + ACTIVITY_ARTICLE_IDS.heartRatePaceSteps;
  }
}
